import type { I18nFn } from '#/i18n/types/I18nFn';

export function SALARY_PERIODS(i18n: I18nFn) {
  return [
    {
      id: 'YEAR',

      /* TRANSLATORS: job view payment time period */
      unit: i18n('year'),

      /* TRANSLATORS: job form payment time period */
      name: i18n('Year'),
    },
    {
      id: 'HOUR',

      /* TRANSLATORS: job view payment time period */
      unit: i18n('hour'),

      /* TRANSLATORS: job form payment time period */
      name: i18n('Hour'),
    },
    {
      id: 'DAY',

      /* TRANSLATORS: job view payment time period */
      unit: i18n('day'),

      /* TRANSLATORS: job form payment time period */
      name: i18n('Day'),
    },
    {
      id: 'WEEK',

      /* TRANSLATORS: job view payment time period */
      unit: i18n('week'),

      /* TRANSLATORS: job form payment time period */
      name: i18n('Week'),
    },
    {
      id: 'MONTH',

      /* TRANSLATORS: job view payment time period */
      unit: i18n('month'),

      /* TRANSLATORS: job form payment time period */
      name: i18n('Month'),
    },
  ] as const;
}

export type SalaryPeriodId = ReturnType<typeof SALARY_PERIODS>[number]['id'];

export function getSalaryPeriodHumanName(i18n: I18nFn, salaryPeriod: string) {
  const SALARY_PERIOD = SALARY_PERIODS(i18n).find(
    (jp) => jp.id === salaryPeriod,
  );

  if (SALARY_PERIOD) {
    return SALARY_PERIOD.unit;
  }
}
